import Trans from 'next-translate/Trans'
import { useState } from 'react'
import GHref from 'tennders-market/common/components/element/GHref'
import { apiPut } from 'tennders-stracture/libs/api'
import { useRouter } from 'next/router'
import { OFFER_STATUS_PASSED } from 'tennders-stracture/libs/constants'

export const DealPassed = (props) => {
  const {
    offer,
    setCounterMode,
    revertBidding,
    refreshOffers,
    isBroker,
    closeTransaction,
    transaction,
    setRefresh
  } = props
  const [submitting, setsubmitting] = useState(false)
  const [reverting, setreverting] = useState(false)
  const router = useRouter()

  const dismiss = async () => {
    await apiPut(`/offers/${offer?.id}/dismiss-passed`, {})
    closeTransaction()
    setRefresh('all')
    if (isBroker() && transaction?.isMine) {
      router.push('/myloads')
    }
  }

  const submit = async () => {
    if (reverting) {
      setsubmitting(true)
      await revertBidding(offer?.id)
      setsubmitting(false)
      refreshOffers()
    } else {
      setreverting(true)
    }
  }

  return offer?.timer && offer?.status?.label === OFFER_STATUS_PASSED
    ? (
      <div className="tennders-under-neg-confirm-congrat p-16 br-6">
        <Trans i18nKey="offer:expiredDeal" />
        { (reverting
          ? (
            <div className="mb-10">
              <GHref
                submitting={submitting}
                onClick={submit}
                className="text-underline tennders-decline-btn-2 ml-24"
              >
                <Trans i18nKey="offer:confirmRevertOperation" />
              </GHref>
            </div>
          )
          : (
            <div className="mt-10 mb-10">
              {!transaction?.isMine && (
                <GHref
                  className="text-underline tennders-decline-btn-2 "
                  onClick={() => setCounterMode(offer?.id)}
                >
                  <Trans i18nKey="offer:resubmit" />
                </GHref>
              )}
              {'   '}
              <GHref
                className="text-underline tennders-decline-btn-2 ml-24"
                onClick={dismiss}
              >
                <Trans i18nKey="common:dismiss" />
              </GHref>
            </div>
          ))}
      </div>
    ) : null
}
